import EditableCard from 'components/EditableCard/EditableCard';
import ColumnWrapper from 'components/Layout/ColumnWrapper';
import { FluidBriefingModelType } from 'models/BriefingModel';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormType } from 'utils/hooks/useForm';

interface FireBriefingComponentProps {
  briefing?: FluidBriefingModelType;
  handleBriefingFieldUpdate: (field: string, value: string) => void;
  form: FormType;
}

const FireBriefingComponent: React.FC<FireBriefingComponentProps> = ({
  briefing,
  handleBriefingFieldUpdate,
  form
}) => {
  if (!briefing || !briefing.question || !briefing.description) {
    return null;
  }

  return (
    <ColumnWrapper gap="0.625em">
      <EditableCard
        shrink={true}
        textSize="medium-large"
        largeFont={true}
        singleLine={true}
        lines={5}
        form={form}
        name="question"
        label={<FormattedMessage id="question long" />}
        value={briefing.question}
        editable={true}
        onSave={() =>
          handleBriefingFieldUpdate('question', form.values['question'])
        }
      />

      <EditableCard
        form={form}
        name="description"
        simple={true}
        label={<FormattedMessage id="Briefing description" />}
        value={briefing.description}
        editable={true}
        onSave={() =>
          handleBriefingFieldUpdate('description', form.values['description'])
        }
      />

      <div className="briefing-detail-row">
        <EditableCard
          form={form}
          shrink={true}
          simple={true}
          name="ai_target_group_description"
          label={<FormattedMessage id="Briefing target description" />}
          value={briefing.ai_target_group_description}
          editable={true}
          onSave={() =>
            handleBriefingFieldUpdate(
              'ai_target_group_description',
              form.values['ai_target_group_description']
            )
          }
        />
        <EditableCard
          form={form}
          shrink={true}
          simple={true}
          name="ai_service_description"
          label={<FormattedMessage id="Briefing service description" />}
          value={briefing.ai_service_description}
          editable={true}
          onSave={() =>
            handleBriefingFieldUpdate(
              'ai_service_description',
              form.values['ai_service_description']
            )
          }
        />
      </div>

      <div className="briefing-detail-row briefing-detail-row--one-third">
        <EditableCard
          form={form}
          shrink={true}
          simple={true}
          name="ai_business_target_description"
          label={<FormattedMessage id="Briefing business target description" />}
          value={briefing.ai_business_target_description}
          editable={true}
          onSave={() =>
            handleBriefingFieldUpdate(
              'ai_business_target_description',
              form.values['ai_business_target_description']
            )
          }
        />
        <EditableCard
          form={form}
          shrink={true}
          simple={true}
          name="ai_characteristic_description"
          label={<FormattedMessage id="Briefing characteristic description" />}
          value={briefing.ai_characteristic_description}
          editable={true}
          onSave={() =>
            handleBriefingFieldUpdate(
              'ai_characteristic_description',
              form.values['ai_characteristic_description']
            )
          }
        />
      </div>
    </ColumnWrapper>
  );
};

export default FireBriefingComponent;
